import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { GET_CONTENT_AVERAGE_RATINGS } from '../queries/contentRatings';

export const useContentRatings = (contentIds) => {
  const uniqueIds = useMemo(
    () => Array.from(new Set((contentIds || []).filter(Boolean))),
    [contentIds],
  );

  const { data, loading, error } = useQuery(GET_CONTENT_AVERAGE_RATINGS, {
    variables: { contentIds: uniqueIds },
    skip: uniqueIds.length === 0,
  });

  const ratingsByContentId = useMemo(() => {
    const result = {};
    (data?.contentAverageRatings || []).forEach((row) => {
      if (!row?.contentId) return;
      result[row.contentId] = {
        avgRating: row.avgRating != null ? Number(row.avgRating) : null,
        reviewCount: row.reviewCount != null ? Number(row.reviewCount) : 0,
      };
    });
    return result;
  }, [data]);

  return { ratingsByContentId, loading, error };
};
